function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var sizes = {
  square: 0.908,
  // ish
  landscape: 0.667,
  letterbox: 0.425,
  portrait: 1.299
};
/**
 * Our standardised image sizes.
 *
 * Includes mapping to the original WP keys, as well as the more succinct
 * versions defined above.
 */

export var imageSizes = Object.freeze(_objectSpread(_objectSpread({}, sizes), {}, {
  landscape_thumbnail: sizes.landscape,
  portrait_thumbnail: sizes.portrait,
  square_thumbnail: sizes.square,
  letterbox_image: sizes.letterbox,
  // The `dynamic` option is a special case for when we want to set the aspect
  // ratio dynamically from the width and height of the image.
  dynamic: null
}));